import { Transition } from "../../../core/flows/Transition";
import { AddShuttleTransferContext } from "../Context/AddShuttleTransferContext";

export class AddShuttleTransferTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {
        const context = this.getCtx<AddShuttleTransferContext>("addShuttleTransferContext", this.entryStep);

        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${this.getCtx("choice")}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}